import script from "./PhoneNumber.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneNumber.vue?vue&type=script&setup=true&lang=js"

import "./PhoneNumber.vue?vue&type=style&index=0&id=921170c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-921170c8"]])

export default __exports__